
import { POS_FRONTEND_BUILD_INFO } from "../common/buildInfo";

const baseApi = process.env.REACT_APP_API_URL;

const defaultHeaders = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-POS-Frontend-Version': POS_FRONTEND_BUILD_INFO.version,
    'X-POS-Frontend-Build': POS_FRONTEND_BUILD_INFO.marker,
};

export const request = {
    get: async (url: string, params?: Record<string, any>) => {
        const queryParams = params ? `?${new URLSearchParams(params)}` : '';
        return (await fetch(`${baseApi}${url}${queryParams}`, {
            headers: defaultHeaders,
        })).json()
    },
    post: async (url: string, body: any) => (await fetch(`${baseApi}${url}`, {
        method: 'POST',
        headers: defaultHeaders,
        body: JSON.stringify(body)
    })).json(),
    put: async (url: string, body?: any) => (await fetch(`${baseApi}${url}`, {
        method: 'PUT',
        headers: defaultHeaders,
        body: body ? JSON.stringify(body) : undefined
    })).json(),
}